export type DesktopWorkspace = { id: string; name: string; path: string };

export type DesktopWorkspacesApi = {
  list: () => Promise<DesktopWorkspace[]>;
  /** Opens the native OS folder picker on the desktop and grants the chosen folder(s). */
  addViaDialog: () => Promise<DesktopWorkspace[]>;
  remove: (id: string) => Promise<DesktopWorkspace[]>;
};

export const isDesktopApp = (): boolean => typeof window !== 'undefined' && 'desktopAPI' in window;

/**
 * The desktop app's workspace-management bridge (exposed via preload as
 * window.desktopAPI.workspaces). Returns null in the web app, so callers must
 * gate on it. Adding a folder triggers the native OS picker on the machine —
 * the secure, physical-presence path Claude/Codex use.
 */
export const getDesktopWorkspacesApi = (): DesktopWorkspacesApi | null =>
  (typeof window !== 'undefined' && window.desktopAPI?.workspaces) || null;
